/**
 * Class name for the Frill widget, required for the frill notification badge to get rendered
 * https://verdiag.frill.co/dashboard/widgets
 */
export const FRILL_WIDGET_CLASS_NAME = "frill-widget";
